import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useTranslation } from "@/context/TranslationContext";

const services = [
  {
    id: "saas",
    icon: "ri-cloud-line",
    titleKey: "services.saas_title",
    taglineKey: "services.saas_tagline",
    color: "electric-blue",
    borderColor: "border-electric-blue/30",
    bgColor: "bg-electric-blue/5",
    iconBg: "bg-electric-blue/10",
    iconColor: "text-electric-blue",
    glowColor: "shadow-glow-blue",
    descriptionKey: "services.saas_description",
    capabilityKeys: [
      "services.saas_cap1",
      "services.saas_cap2",
      "services.saas_cap3",
      "services.saas_cap4",
      "services.saas_cap5",
      "services.saas_cap6",
      "services.saas_cap7",
      "services.saas_cap8",
    ],
    techStack: ["React", "Node.js", "PostgreSQL", "Redis", "Stripe", "Docker", "AWS"],
    deliverableKeys: ["services.saas_deliverable1", "services.saas_deliverable2", "services.saas_deliverable3", "services.saas_deliverable4"],
    timelineKey: "services.saas_timeline",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "web-mobile",
    icon: "ri-smartphone-line",
    titleKey: "services.web_mobile_title",
    taglineKey: "services.web_mobile_tagline",
    color: "cyber-green",
    borderColor: "border-cyber-green/30",
    bgColor: "bg-cyber-green/5",
    iconBg: "bg-cyber-green/10",
    iconColor: "text-cyber-green",
    glowColor: "shadow-glow-green",
    descriptionKey: "services.web_mobile_description",
    capabilityKeys: [
      "services.web_mobile_cap1",
      "services.web_mobile_cap2",
      "services.web_mobile_cap3",
      "services.web_mobile_cap4",
      "services.web_mobile_cap5",
      "services.web_mobile_cap6",
      "services.web_mobile_cap7",
      "services.web_mobile_cap8",
    ],
    techStack: ["React", "React Native", "TypeScript", "Tailwind CSS", "Expo", "Firebase"],
    deliverableKeys: ["services.web_mobile_deliverable1", "services.web_mobile_deliverable2", "services.web_mobile_deliverable3", "services.web_mobile_deliverable4"],
    timelineKey: "services.web_mobile_timeline",
    image: "https://images.unsplash.com/photo-1558655146-364adaf1fcc9?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: "automation",
    icon: "ri-robot-line",
    titleKey: "services.automation_title",
    taglineKey: "services.automation_tagline",
    color: "cyber-orange",
    borderColor: "border-cyber-orange/30",
    bgColor: "bg-cyber-orange/5",
    iconBg: "bg-cyber-orange/10",
    iconColor: "text-cyber-orange",
    glowColor: "shadow-glow-red",
    descriptionKey: "services.automation_description",
    capabilityKeys: [
      "services.automation_cap1",
      "services.automation_cap2",
      "services.automation_cap3",
      "services.automation_cap4",
      "services.automation_cap5",
      "services.automation_cap6",
      "services.automation_cap7",
    ],
    techStack: ["Node.js", "Python", "n8n", "Zapier", "PostgreSQL", "RabbitMQ", "Puppeteer"],
    deliverableKeys: ["services.automation_deliverable1", "services.automation_deliverable2", "services.automation_deliverable3", "services.automation_deliverable4"],
    timelineKey: "services.automation_timeline",
    image: "https://images.unsplash.com/photo-1563520240533-66480a3916fe?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: "fintech",
    icon: "ri-bank-line",
    titleKey: "services.fintech_title",
    taglineKey: "services.fintech_tagline",
    color: "electric-blue",
    borderColor: "border-electric-blue/30",
    bgColor: "bg-electric-blue/5",
    iconBg: "bg-electric-blue/10",
    iconColor: "text-electric-blue",
    glowColor: "shadow-glow-blue",
    descriptionKey: "services.fintech_description",
    capabilityKeys: [
      "services.fintech_cap1",
      "services.fintech_cap2",
      "services.fintech_cap3",
      "services.fintech_cap4",
      "services.fintech_cap5",
      "services.fintech_cap6",
    ],
    techStack: ["Node.js", "PostgreSQL", "Stripe", "Plaid", "Redis", "AWS KMS", "Docker"],
    deliverableKeys: ["services.fintech_deliverable1", "services.fintech_deliverable2", "services.fintech_deliverable3", "services.fintech_deliverable4"],
    timelineKey: "services.fintech_timeline",
    image: "https://images.unsplash.com/photo-1765226410758-9ae3d34cd791?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "trading",
    icon: "ri-line-chart-line",
    titleKey: "services.trading_title",
    taglineKey: "services.trading_tagline",
    color: "cyber-red",
    borderColor: "border-cyber-red/30",
    bgColor: "bg-cyber-red/5",
    iconBg: "bg-cyber-red/10",
    iconColor: "text-cyber-red",
    glowColor: "shadow-glow-red",
    descriptionKey: "services.trading_description",
    capabilityKeys: [
      "services.trading_cap1",
      "services.trading_cap2",
      "services.trading_cap3",
      "services.trading_cap4",
      "services.trading_cap5",
      "services.trading_cap6",
      "services.trading_cap7",
      "services.trading_cap8",
    ],
    techStack: ["Python", "Node.js", "PostgreSQL", "Redis", "WebSocket", "InfluxDB", "Docker"],
    deliverableKeys: ["services.trading_deliverable1", "services.trading_deliverable2", "services.trading_deliverable3", "services.trading_deliverable4"],
    timelineKey: "services.trading_timeline",
    image: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "ai",
    icon: "ri-brain-line",
    titleKey: "services.ai_title",
    taglineKey: "services.ai_tagline",
    color: "cyber-green",
    borderColor: "border-cyber-green/30",
    bgColor: "bg-cyber-green/5",
    iconBg: "bg-cyber-green/10",
    iconColor: "text-cyber-green",
    glowColor: "shadow-glow-green",
    descriptionKey: "services.ai_description",
    capabilityKeys: [
      "services.ai_cap1",
      "services.ai_cap2",
      "services.ai_cap3",
      "services.ai_cap4",
      "services.ai_cap5",
      "services.ai_cap6",
      "services.ai_cap7",
      "services.ai_cap8",
    ],
    techStack: ["Python", "LangChain", "OpenAI", "Pinecone", "FastAPI", "PostgreSQL", "Docker"],
    deliverableKeys: ["services.ai_deliverable1", "services.ai_deliverable2", "services.ai_deliverable3", "services.ai_deliverable4"],
    timelineKey: "services.ai_timeline",
    image: "https://plus.unsplash.com/premium_photo-1764687620875-7561d3040734?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "branding",
    icon: "ri-brush-line",
    titleKey: "services.branding_title",
    taglineKey: "services.branding_tagline",
    color: "cyber-orange",
    borderColor: "border-cyber-orange/30",
    bgColor: "bg-cyber-orange/5",
    iconBg: "bg-cyber-orange/10",
    iconColor: "text-cyber-orange",
    glowColor: "shadow-glow-red",
    descriptionKey: "services.branding_description",
    capabilityKeys: [
      "services.branding_cap1",
      "services.branding_cap2",
      "services.branding_cap3",
      "services.branding_cap4",
      "services.branding_cap5",
      "services.branding_cap6",
      "services.branding_cap7",
    ],
    techStack: ["Adobe Illustrator", "Figma", "Adobe Photoshop", "Canva Pro", "Inkscape"],
    deliverableKeys: ["services.branding_deliverable1", "services.branding_deliverable2", "services.branding_deliverable3", "services.branding_deliverable4"],
    timelineKey: "services.branding_timeline",
    image: "https://images.unsplash.com/photo-1636247498719-a8a04ed961a4?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "flyers",
    icon: "ri-image-edit-line",
    titleKey: "services.flyers_title",
    taglineKey: "services.flyers_tagline",
    color: "cyber-green",
    borderColor: "border-cyber-green/30",
    bgColor: "bg-cyber-green/5",
    iconBg: "bg-cyber-green/10",
    iconColor: "text-cyber-green",
    glowColor: "shadow-glow-green",
    descriptionKey: "services.flyers_description",
    capabilityKeys: [
      "services.flyers_cap1",
      "services.flyers_cap2",
      "services.flyers_cap3",
      "services.flyers_cap4",
      "services.flyers_cap5",
      "services.flyers_cap6",
    ],
    techStack: ["Adobe InDesign", "Canva", "Figma", "Adobe Photoshop"],
    deliverableKeys: ["services.flyers_deliverable1", "services.flyers_deliverable2", "services.flyers_deliverable3", "services.flyers_deliverable4"],
    timelineKey: "services.flyers_timeline",
    image: "https://images.unsplash.com/photo-1636247499734-893da2bcfc1c?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "hardware",
    icon: "ri-cpu-line",
    titleKey: "services.hardware_title",
    taglineKey: "services.hardware_tagline",
    color: "cyber-red",
    borderColor: "border-cyber-red/30",
    bgColor: "bg-cyber-red/5",
    iconBg: "bg-cyber-red/10",
    iconColor: "text-cyber-red",
    glowColor: "shadow-glow-red",
    descriptionKey: "services.hardware_description",
    capabilityKeys: [
      "services.hardware_cap1",
      "services.hardware_cap2",
      "services.hardware_cap3",
      "services.hardware_cap4",
      "services.hardware_cap5",
      "services.hardware_cap6",
    ],
    techStack: ["Arduino", "Raspberry Pi", "OpenWrt", "Serial/FTDI tools", "BIOS utilities", "Diagnostic software"],
    deliverableKeys: ["services.hardware_deliverable1", "services.hardware_deliverable2", "services.hardware_deliverable3", "services.hardware_deliverable4"],
    timelineKey: "services.hardware_timeline",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "it-support",
    icon: "ri-customer-service-2-line",
    titleKey: "services.it_support_title",
    taglineKey: "services.it_support_tagline",
    color: "cyber-green",
    borderColor: "border-cyber-green/30",
    bgColor: "bg-cyber-green/5",
    iconBg: "bg-cyber-green/10",
    iconColor: "text-cyber-green",
    glowColor: "shadow-glow-green",
    descriptionKey: "services.it_support_description",
    capabilityKeys: [
      "services.it_support_cap1",
      "services.it_support_cap2",
      "services.it_support_cap3",
      "services.it_support_cap4",
      "services.it_support_cap5",
      "services.it_support_cap6",
      "services.it_support_cap7",
    ],
    techStack: ["Windows", "macOS", "Linux", "TeamViewer", "AnyDesk", "Bitdefender"],
    deliverableKeys: ["services.it_support_deliverable1", "services.it_support_deliverable2", "services.it_support_deliverable3", "services.it_support_deliverable4"],
    timelineKey: "services.it_support_timeline",
    image: "https://plus.unsplash.com/premium_photo-1661421653831-d0d818b0594f?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "hosting",
    icon: "ri-server-line",
    titleKey: "services.hosting_title",
    taglineKey: "services.hosting_tagline",
    color: "electric-blue",
    borderColor: "border-electric-blue/30",
    bgColor: "bg-electric-blue/5",
    iconBg: "bg-electric-blue/10",
    iconColor: "text-electric-blue",
    glowColor: "shadow-glow-blue",
    descriptionKey: "services.hosting_description",
    capabilityKeys: [
      "services.hosting_cap1",
      "services.hosting_cap2",
      "services.hosting_cap3",
      "services.hosting_cap4",
      "services.hosting_cap5",
      "services.hosting_cap6",
      "services.hosting_cap7",
    ],
    techStack: ["cPanel", "Apache", "Nginx", "Cloudflare", "AWS", "Ubuntu", "CentOS"],
    deliverableKeys: ["services.hosting_deliverable1", "services.hosting_deliverable2", "services.hosting_deliverable3", "services.hosting_deliverable4", "services.hosting_deliverable5"],
    timelineKey: "services.hosting_timeline",
    image: "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "networking",
    icon: "ri-wifi-line",
    titleKey: "services.networking_title",
    taglineKey: "services.networking_tagline",
    color: "cyber-blue",
    borderColor: "border-cyber-blue/30",
    bgColor: "bg-cyber-blue/5",
    iconBg: "bg-cyber-blue/10",
    iconColor: "text-cyber-blue",
    glowColor: "shadow-glow-blue",
    descriptionKey: "services.networking_description",
    capabilityKeys: [
      "services.networking_cap1",
      "services.networking_cap2",
      "services.networking_cap3",
      "services.networking_cap4",
      "services.networking_cap5",
      "services.networking_cap6",
      "services.networking_cap7",
    ],
    techStack: ["Cisco IOS", "GNS3", "Packet Tracer", "pfSense", "OpenWrt", "Wireshark", "Ubiquiti UniFi"],
    deliverableKeys: ["services.networking_deliverable1", "services.networking_deliverable2", "services.networking_deliverable3", "services.networking_deliverable4", "services.networking_deliverable5"],
    timelineKey: "services.networking_timeline",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=800&q=80",
  },
];

const processSteps = [
  { icon: "ri-search-eye-line", titleKey: "services.step1_title", descKey: "services.step1_desc" },
  { icon: "ri-layout-masonry-line", titleKey: "services.step2_title", descKey: "services.step2_desc" },
  { icon: "ri-code-s-slash-line", titleKey: "services.step3_title", descKey: "services.step3_desc" },
  { icon: "ri-shield-check-line", titleKey: "services.step4_title", descKey: "services.step4_desc" },
  { icon: "ri-rocket-line", titleKey: "services.step5_title", descKey: "services.step5_desc" },
];

const techCategories = [
  { label: "Frontend", items: ["React", "TypeScript", "Tailwind CSS", "Next.js", "React Native"] },
  { label: "Backend", items: ["Node.js", "Express", "Python", "FastAPI", "GraphQL"] },
  { label: "Database", items: ["PostgreSQL", "Redis", "MongoDB", "InfluxDB", "Supabase"] },
  { label: "AI & ML", items: ["OpenAI", "LangChain", "Pinecone", "HuggingFace", "TensorFlow"] },
  { label: "Payments", items: ["Stripe", "Paystack", "Flutterwave", "Plaid", "Mono"] },
  { label: "Infrastructure", items: ["AWS", "Docker", "Kubernetes", "GitHub Actions", "Nginx"] },
];

export default function Services() {
  const { t } = useTranslation();
  const [activeService, setActiveService] = useState(services[0].id);
  const active = services.find((s) => s.id === activeService) || services[0];

  return (
    <div className="min-h-screen bg-deep-black font-inter">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-36 pb-20 px-4 md:px-12 lg:px-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20futuristic%20abstract%20technology%20background%20with%20glowing%20blue%20circuit%20patterns%2C%20digital%20data%20streams%2C%20deep%20space%20atmosphere%2C%20electric%20blue%20light%20trails%2C%20ultra%20cinematic%2C%20no%20people%2C%20pure%20abstract%20tech&width=1920&height=600&seq=services-hero-bg-001&orientation=landscape"
            alt="Services background"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-deep-black/60 via-deep-black/40 to-deep-black" />
          <div className="absolute inset-0 bg-circuit-pattern opacity-40" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-5 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("services.hero_badge")}
            </span>
            <h1 className="font-black text-white leading-tight mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(2.5rem, 5vw, 4.5rem)" }}>
              {t("services.hero_title")}<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric-blue via-cyan-400 to-cyber-blue">
                {t("services.hero_highlight")}
              </span>
            </h1>
            <p className="text-silver text-base md:text-lg max-w-2xl leading-relaxed mb-10">
              {t("services.hero_description")}
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <Link
                to="/pricing"
                className="flex items-center gap-2 bg-electric-blue text-deep-black font-bold px-8 py-3.5 rounded-full hover:shadow-glow-blue transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                {t("services.cta_primary")}
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/portfolio"
                className="flex items-center gap-2 border border-dark-border text-silver hover:border-electric-blue/30 hover:text-white px-8 py-3.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                {t("services.cta_secondary")}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service Selector */}
      <section className="md:sticky top-[68px] z-30 bg-deep-black/96 backdrop-blur-xl border-b border-dark-border px-4 md:px-12 lg:px-20 py-3">
        <div className="max-w-7xl mx-auto flex flex-wrap gap-2">
          {services.map((s) => (
            <button
              key={s.id}
              onClick={() => setActiveService(s.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeService === s.id
                  ? `bg-electric-blue text-deep-black`
                  : "border border-dark-border text-silver hover:border-electric-blue/30 hover:text-white"
              }`}
            >
              <i className={`${s.icon} text-xs`} />
              {t(s.titleKey)}
            </button>
          ))}
        </div>
      </section>

      {/* Active Service Detail */}
      <section className="py-20 px-4 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left: Info */}
            <div>
              <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border ${active.borderColor} ${active.bgColor} mb-6`}>
                <div className={`w-4 h-4 flex items-center justify-center ${active.iconColor}`}>
                  <i className={`${active.icon} text-xs`} />
                </div>
                <span className={`text-xs font-semibold uppercase tracking-[0.15em] ${active.iconColor}`}>
                  {t(active.taglineKey)}
                </span>
              </div>

              <h2 className="font-black text-white mb-5" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(2rem, 4vw, 3rem)" }}>
                {t(active.titleKey)}
              </h2>
              <p className="text-silver text-base leading-relaxed mb-8">
                {t(active.descriptionKey)}
              </p>

              {/* Meta */}
              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className={`p-4 rounded-xl border ${active.borderColor} ${active.bgColor}`}>
                  <div className="text-silver-dim text-xs uppercase tracking-widest mb-1">{t("services.timeline")}</div>
                  <div className={`font-bold text-sm ${active.iconColor}`}>{t(active.timelineKey)}</div>
                </div>
                <div className={`p-4 rounded-xl border ${active.borderColor} ${active.bgColor}`}>
                  <div className="text-silver-dim text-xs uppercase tracking-widest mb-1">{t("services.deliverables")}</div>
                  <div className="font-bold text-sm text-white">{active.deliverableKeys.length} items</div>
                </div>
              </div>

              {/* Capabilities */}
              <h3 className="text-white font-bold text-xs uppercase tracking-[0.15em] mb-4">{t("services.capabilities")}</h3>
              <ul className="space-y-2.5 mb-8">
                {active.capabilityKeys.map((capKey) => (
                  <li key={capKey} className="flex items-start gap-3 text-sm">
                    <div className={`w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0 rounded-full bg-electric-blue/10 border border-electric-blue/20 ${active.iconColor}`}>
                      <i className="ri-check-line text-xs" />
                    </div>
                    <span className="text-silver">{t(capKey)}</span>
                  </li>
                ))}
              </ul>

              {/* Tech Stack */}
              <h3 className="text-white font-bold text-xs uppercase tracking-[0.15em] mb-4">{t("services.tech_stack")}</h3>
              <div className="flex flex-wrap gap-2 mb-8">
                {active.techStack.map((tech) => (
                  <span
                    key={tech}
                    className={`text-xs px-3 py-1.5 rounded-full border ${active.borderColor} ${active.bgColor} ${active.iconColor} font-medium`}
                  >
                    {tech}
                  </span>
                ))}
              </div>

              {/* Deliverables */}
              <h3 className="text-white font-bold text-xs uppercase tracking-[0.15em] mb-4">{t("services.what_you_get")}</h3>
              <div className="grid grid-cols-2 gap-2 mb-10">
                {active.deliverableKeys.map((delKey) => (
                  <div key={delKey} className="flex items-center gap-2 text-sm text-silver">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className={`ri-checkbox-circle-line text-sm ${active.iconColor}`} />
                    </div>
                    {t(delKey)}
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/pricing"
                  className="flex items-center justify-center gap-2 bg-electric-blue text-deep-black font-bold px-6 py-3 rounded-full hover:shadow-glow-blue transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                >
                  {t("services.get_quote")}
                  <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/portfolio"
                  className="flex items-center justify-center gap-2 border border-dark-border text-silver hover:border-electric-blue/30 hover:text-white px-6 py-3 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                >
                  {t("services.see_examples")}
                </Link>
              </div>
            </div>

            {/* Right: Image */}
            <div className="relative">
              <div className={`absolute -inset-4 rounded-3xl ${active.bgColor} blur-2xl opacity-30`} />
              <div className={`relative rounded-2xl border ${active.borderColor} overflow-hidden`}>
                <img
                  src={active.image}
                  alt={active.title}
                  className="w-full h-80 object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-card/60 to-transparent" />
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* All Services Grid */}
      <section className="py-20 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-4 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("services.all_services_badge")}
            </span>
            <h2 className="font-black text-white" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(1.8rem, 3vw, 2.8rem)" }}>
              {t("services.all_services_title")}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s) => (
              <button
                key={s.id}
                onClick={() => {
                  setActiveService(s.id);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={`text-left group relative border rounded-2xl p-6 transition-all duration-300 cursor-pointer ${
                  activeService === s.id
                    ? `${s.borderColor} ${s.bgColor}`
                    : "border-dark-border bg-dark-card hover:border-electric-blue/20"
                }`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${s.iconBg} border border-dark-border mb-4 ${s.iconColor}`}>
                  <i className={`${s.icon} text-xl`} />
                </div>
                <h3 className="text-white font-bold text-base mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {t(s.titleKey)}
                </h3>
                <p className="text-silver-dim text-sm leading-relaxed mb-4 line-clamp-2">
                  {t(s.descriptionKey)}
                </p>
                <div className={`flex items-center gap-1 text-xs font-medium ${s.iconColor} opacity-0 group-hover:opacity-100 transition-opacity`}>
                  {t("services.explore_service")} <i className="ri-arrow-right-line" />
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 px-4 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-4 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("services.process_badge")}
            </span>
            <h2 className="font-black text-white" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(1.8rem, 3vw, 2.8rem)" }}>
              {t("services.process_title")}
            </h2>
          </div>
          <div className="relative">
            <div className="hidden lg:block absolute top-8 left-0 right-0 h-px bg-gradient-to-r from-transparent via-electric-blue/20 to-transparent" />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
              {processSteps.map((step, i) => (
                <div key={step.titleKey} className="relative group text-center lg:text-left">
                  <div className="relative w-16 h-16 flex items-center justify-center rounded-2xl bg-dark-card border border-dark-border group-hover:border-electric-blue/40 transition-all duration-300 mx-auto lg:mx-0 mb-4">
                    <i className={`${step.icon} text-xl text-electric-blue`} />
                    <div className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-deep-black border border-electric-blue/40 text-electric-blue text-xs font-bold">
                      {i + 1}
                    </div>
                  </div>
                  <h3 className="text-white font-bold text-sm mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                    {t(step.titleKey)}
                  </h3>
                  <p className="text-silver-dim text-xs leading-relaxed">{t(step.descKey)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Tech Stack */}
      <section className="py-20 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-4 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("services.tech_badge")}
            </span>
            <h2 className="font-black text-white" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(1.8rem, 3vw, 2.8rem)" }}>
              {t("services.tech_title")}
            </h2>
            <p className="text-silver text-sm mt-3 max-w-xl mx-auto">
              {t("services.tech_description")}
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {techCategories.map((cat) => (
              <div key={cat.label} className="bg-dark-card border border-dark-border rounded-2xl p-6 hover:border-electric-blue/20 transition-colors">
                <h3 className="text-electric-blue font-bold text-xs uppercase tracking-[0.15em] mb-4">{cat.label}</h3>
                <div className="flex flex-wrap gap-2">
                  {cat.items.map((item) => (
                    <span
                      key={item}
                      className="text-sm px-3 py-1.5 rounded-lg bg-deep-black border border-dark-border text-silver font-medium"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-4 md:px-12 lg:px-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20abstract%20technology%20background%20with%20glowing%20blue%20geometric%20patterns%2C%20circuit%20board%20art%2C%20deep%20space%20atmosphere%2C%20electric%20blue%20light%20beams%2C%20cinematic%20dark%20sci-fi&width=1920&height=500&seq=services-cta-bg-001&orientation=landscape"
            alt="CTA background"
            className="w-full h-full object-cover object-top opacity-10"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/90 to-deep-black" />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h2 className="font-black text-white mb-5" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
            {t("services.cta_title")}<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric-blue to-cyber-blue">
              {t("services.cta_highlight")}
            </span>
          </h2>
          <p className="text-silver text-base mb-10 leading-relaxed">
            {t("services.cta_description")}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/pricing"
              className="flex items-center gap-2 bg-electric-blue text-deep-black font-bold px-8 py-4 rounded-full hover:shadow-glow-blue transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t("services.cta_button")}
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/portfolio"
              className="flex items-center gap-2 border border-dark-border text-silver hover:border-electric-blue/30 hover:text-white px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t("services.cta_secondary_button")}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
